module.exports = __webpack_public_path__ + "img/android-chrome-512x512.452677f1.png";